import { lazy } from 'react';

import { featureEnabled } from '@grafana/runtime';
import { FlagKeys, getFeatureFlagClient } from '@grafana/runtime/internal';
import { contextSrv } from 'app/core/services/context_srv';
import { AccessControlAction } from 'app/types/accessControl';

export function getSmtpSettingsRoutes() {
  // The flag keeps the page in sync with the Go nav link, since the frontend can run against an older backend.
  if (!featureEnabled('grafanacloud') || !getFeatureFlagClient().getBooleanValue(FlagKeys.GrafanaSmtpSettingsPage, false)) {
    return [];
  }
  return [
    {
      path: SMTP_SETTINGS_URL,
      // Bootdata only knows the action, not its scope. The backend enforces the settings:smtp:* scope and
      // the page shows its permission alert on a 403/404.
      roles: () => contextSrv.evaluatePermission([AccessControlAction.SettingsWrite]),
      component: lazy(() => import(/* webpackChunkName: "SmtpSettingsPage" */ './SmtpSettingsPage')),
    },
  ];
}

const SMTP_SETTINGS_URL = '/admin/settings/smtp';
